import { Beneficiary } from "./Beneficiary";

/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

export const productGOTypes = [
    { name: "pco", label: "Prima Capital Obsèques+" },
    { name: "pvo", label: "Prima Volontés Obsèques+" }
];

export const productGOPvoFormulas = [
    { name: "initial", label: "Formule initiale 3400 €" },
    { name: "serenity", label: "Formule sérénité 4100 €" },
    { name: "prestige", label: "Formule prestige 5900 €" }
];

export const productGOContributionMethods = [
    // { name: "lifetime", label: "Viagère" },
    { name: "unique", label: "Unique" },
    { name: "temporary", label: "Temporaire de" }
];

export const productGOSamplingIntervals = [
    { name: "month", label: "Mensuel" },
    { name: "trimester", label: "Trimestriel" },
    { name: "year", label: "Annuel" }
];

export const productGOContributionTemporaryValue = [
    { name: "5", label: "5" },
    { name: "6", label: "6" },
    { name: "7", label: "7" },
    { name: "8", label: "8" },
    { name: "9", label: "9" },
    { name: "10", label: "10" },
    { name: "11", label: "11" },
    { name: "12", label: "12" },
    { name: "13", label: "13" },
    { name: "14", label: "14" },
    { name: "15", label: "15" }
];

export const productGOBeneficiaryClauseItems = [
    { name: "standard", label: "Clause standard : le conjoint de l'assuré non séparé judiciairement, à défaut les enfants de l'assuré " +
        "nés ou à naître, vivants ou représentés, à défaut les héritiers de l'assuré." },
    { name: "beneficiary", label: "Clause libre : autre(s) bénéficiaire(s). " +
        "Merci de renseigner précisément les informations ci-dessous." },
];

export interface ProductGO {
    type?: "pco" | "pvo";

    pcoGuaranteedCapitalAmount?: number;

    pvoFormula?: "initial" | "serenity" | "prestige";
    
    contributionMethod?: "lifetime" | "temporary" | "unique";
    samplingInterval?: "month" | "trimester" | "year";
    contributionTemporaryValue?: "5" | "10" | "15";
    contribution?: number;

    beneficiaryClause?: "standard" | "beneficiary";
    beneficiaries: Beneficiary[];
}



// WEBPACK FOOTER //
// ./src/types/ProductGO.ts